import { Card } from '@mantine/core';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainCard = asPlainComponent<ComponentProps<typeof Card>>(Card);

export const SlotCard = styled(PlainCard)`
	padding: 0.5rem 0.75rem;
	border: 1px dashed ${defaultTheme.v3.colors.gray[5]};
	border-radius: 0.25rem;
	background: transparent;
`;
